import * as React from 'react';
import Dialog from 'react-toolbox/lib/dialog';
export var ConfirmationDialog = function ConfirmationDialog(_ref) {
        var onConfirm = _ref.onConfirm,
            onClose = _ref.onClose,
            onConfirmLabel = _ref.onConfirmLabel,
            onCloseLabel = _ref.onCloseLabel,
            title = _ref.title,
            open = _ref.open,
            children = _ref.children,
            intl = _ref.intl;
        return React.createElement(Dialog, { title: title, active: open, type: 'small', onEscKeyDown: onClose, onOverlayClick: onClose, actions: [{ label: onCloseLabel, onClick: onClose }, { label: onConfirmLabel, onClick: onConfirm }], children: children });
};
//# sourceMappingURL=confirmation-dialog.js.map
